/**
 * Re-export of the shared CountdownTimer component for the storefront renderer.
 * The base component (render + fields + defaults) lives in
 * `@launchstore/shared-puck`. The renderer uses it as-is. Consumers that
 * want client-side nav for the CTA can wrap the rendered component.
 *
 * See launchstore-shared/src/puck/components/homepage/CountdownTimer/ for source.
 */
import { CountdownTimer as SharedCountdownTimer } from '@launchstore/shared-puck';

export const CountdownTimer: any = SharedCountdownTimer;
export type { CountdownTimerProps } from '@launchstore/shared-puck';
export default CountdownTimer;
